<template>
    <div class="row">
      <template v-if="selectedService?.slug === 'vlan24-cloud'">
        <VlanCloudServerForm />
      </template>
      <template v-else>
        <CloudServerForm />
      </template>
    </div>
  </template>
  
  <script>
    import {mapGetters} from "vuex";
    import CloudServerForm from "@/views/services/cloud_servers/CloudServerForm.vue";
    import VlanCloudServerForm from "@/views/services/cloud_servers/VlanCloudServerForm.vue";
    export default {
        name: 'CreateCloudServerForm',
        components: {VlanCloudServerForm, CloudServerForm},
        data(){
            return {
              selectedService: null
            }
        },
        computed:{
            ...mapGetters({
              customer: 'auth/getUserInfo',
              services: 'auth/getCustomerServices',
            }),
        },
      watch: {
        customer: {
          handler(newVal, oldVal) {
            if (newVal?.selected_service_id !== oldVal?.selected_service_id) {
              // Perform actions when selected_service_id changes
              const newService = this.services.find((item) => item.id === parseInt(newVal?.selected_service_id));
              if (newService) {
                this.selectedService = newService
              } else {
                console.log('No matching service found');
              }
            }
          },
          deep: true, // Watch for changes in nested properties
          immediate: true, // Optional: Run the watcher immediately on component creation
        },
      },
    }
  </script>
  <style scoped>

  </style>
  